import { useEffect, useState } from "react";
import { motion, useMotionValue, animate } from "framer-motion";

export default function AnimatedNumber({
  value = 0,
  prefix = "",
  suffix = "",
  duration = 1.6,
  format = (n) => n.toLocaleString(),
  className = "",
}) {
  const mv = useMotionValue(0);
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const controls = animate(mv, value, {
      duration,
      ease: [0.22, 0.61, 0.36, 1],
      onUpdate: (v) => setDisplay(v),
    });
    return controls.stop;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <motion.span className={className}>
      {prefix}
      {format(Math.round(display))}
      {suffix}
    </motion.span>
  );
}
